import React from "react";
import { Link } from "react-router-dom";
import { dishes } from "../data/dishes";
import { ambassadorBenefits, ambassadorSteps, ambassadorTiers, ambassadorPhotos, ambassadorFaqs } from "../data/ambassador";
import { useTheme, useDocumentTitle } from "../hooks/useSite";
import FaqList from "../components/FaqList";
import SpeechBubble from "../components/SpeechBubble";
import { Host } from "../illustrations";

export default function AmbassadorPage() {
  useTheme(dishes[1]);
  useDocumentTitle("RollOver Ambassador");
  return (
    <>
      <section className="ro-faq-intro">
        <div className="ro-container ro-split ro-faq-intro__split">
          <div>
            <h1>
              <strong className="ro-italic">RollOver</strong>
              <br />
              <span className="ro-outline ro-outline--light">Ambassador</span>
            </h1>
            <p>Share your love for RollOver food with friends and followers.</p>
            <p>The programme is being set up. Register your interest now and the café will share the rewards and terms when it opens.</p>
            <Link className="ro-pill" to="/club" style={{ marginTop: 30 }}>
              Register your interest
            </Link>
          </div>
          <Host className="ro-faq-intro__host" />
        </div>
      </section>
      <section className="ro-benefits ro-benefits--plain">
        <div className="ro-container">
          <h2 className="ro-collection-sub">
            What ambassadors <span className="ro-outline">get.</span>
          </h2>
          <div className="ro-benefits__grid">
            {ambassadorBenefits.map((b) => (
              <article className="ro-benefit" key={b.title}>
                <img src={b.icon} alt="" className="ro-benefit__icon" />
                <div>
                  <h3 className="ro-italic">{b.title}</h3>
                  <p>{b.text}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
      <section className="ro-section">
        <div className="ro-container">
          <h2 className="ro-collection-sub">
            How it <span className="ro-outline">works.</span>
          </h2>
          <ol className="ro-steps">
            {ambassadorSteps.map((s, i) => (
              <li key={s.title} className="ro-step">
                <span className="ro-step__num ro-italic">{i + 1}</span>
                <img src={s.icon} alt="" />
                <h3 className="ro-italic">{s.title}</h3>
                <p>{s.text}</p>
              </li>
            ))}
          </ol>
          <div className="ro-tiers">
            {ambassadorTiers.map((t) => (
              <div key={t.name} className="ro-tier">
                <img src={t.icon} alt="" />
                <span className="ro-italic">{t.name}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="ro-section ro-tinted">
        <div className="ro-container ro-split">
          <div className="ro-ambassador-photos">
            {ambassadorPhotos.map((p) => (
              <img key={p.src} src={p.src} alt={p.alt} loading="lazy" />
            ))}
          </div>
          <div>
            <h2>
              Share your <span className="ro-outline">RollOver moments.</span>
            </h2>
            <p className="ro-lead" style={{ margin: "24px 0 30px" }}>
              Tag RollOver Warangal on Instagram, Facebook or YouTube. The café features its favourite posts.
            </p>
            <SpeechBubble to="/club">
              Count me in.
              <br />
              Join the club
            </SpeechBubble>
          </div>
        </div>
      </section>
      <section className="ro-section">
        <div className="ro-container ro-faq-wrap">
          <h2 style={{ marginBottom: 30 }}>
            Ambassador <span className="ro-outline">questions.</span>
          </h2>
          <FaqList items={ambassadorFaqs} />
        </div>
      </section>
    </>
  );
}
